// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"1aef3dc2","603":"6235bb02","731":"6235bb02","769":"6235bb02"}[chunkId] + ".chunk.css";
};